<template>
  <Modal :open="open" @close="$emit('close')">
    <FormField
      id="monthly_sales_target"
      name="monthly_sales_target"
      type="number"
      :label="t('label')"
      v-model="monthlySalesTarget"
    />
    <div class="flex justify-end mt-4">
      <GenericButton data-test="submit" :disabled="!isValid || saving" @click="save">{{ t("submit") }}</GenericButton>
    </div>
  </Modal>
</template>

<script>
import { mapActions } from "vuex";
import { useI18n } from "vue-i18n";
import { FormField, GenericButton, Modal } from "@estaly/ui";

export default {
  components: { FormField, GenericButton, Modal },

  props: {
    open: { type: Boolean, default: false },
    storeId: { type: Number, required: true },
    currentMonthlySalesTarget: { type: Number, default: null },
  },

  emits: ["close", "updated"],

  setup() {
    const { t } = useI18n();
    return { t };
  },

  data() {
    return {
      monthlySalesTarget: this.currentMonthlySalesTarget,
      saving: false,
    };
  },

  computed: {
    isValid() {
      const value = Number(this.monthlySalesTarget);
      return Number.isInteger(value) && value > 0;
    },
  },

  watch: {
    open(isOpen) {
      if (isOpen) this.monthlySalesTarget = this.currentMonthlySalesTarget;
    },
  },

  methods: {
    ...mapActions("stores", ["update"]),
    ...mapActions("notifications", ["notify"]),

    async save() {
      this.saving = true;
      try {
        const response = await this.update({
          storeId: this.storeId,
          data: { monthlySalesTarget: Number(this.monthlySalesTarget) },
        });
        if (!response?.success) return;

        await this.notify({ category: "simple", type: "success", title: this.t("updated") });
        this.$emit("updated");
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<i18n src="./StoreMonthlySalesTargetModal.i18n.json"></i18n>
